export default __webpack_public_path__ + "static/media/right.4e6847fb.png";